import React from 'react';
import { analyticsConfig } from '../../lib/analytics';
export default function AdminAnalytics() {
  return <section className="section-settings">
    <h2 className="section-title">آمار بازدید سایت</h2>
    <div className="settings-card">
      <h3>گزارش‌های کاوک در PostHog</h3>
      <p>گزارش بازدیدکنندگان، بازدید صفحات، منبع ورود، دستگاه و کشور را در بخش Web Analytics حساب شرکت مشاهده کنید.</p>
      <a className="btn-gold" href={analyticsConfig.reportsUrl} target="_blank" rel="noopener noreferrer">باز کردن گزارش‌های شرکت</a>
      <p className="settings-hint">ثبت آمار پس از انتشار این بیلد روی دامنهٔ کاوک شروع می‌شود. پیش‌نمایش محلی و صفحات ادمین شمرده نمی‌شوند. برای دیدن گزارش‌ها باید با حساب PostHog شرکت وارد شوید؛ این پنل کلید خصوصی گزارش‌ها را نگه نمی‌دارد.</p>
    </div>
  </section>;
}
